import { useCallback, useContext } from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { AjaxContext, formatListData, AppContext, EMPTY_ARRAY, UserContext } from 'commons-ui';

import { UserDetailsContext } from 'context/userDetails';
import { USER_PROFILE_RESOURCES, USER_PAYMENTS_STATUS_RESOURCES, ACTION } from 'constant';
import { WithdrawalsFilters } from './constants';

const useService = () => {
	const { app } = useContext(AppContext);
	const { postData } = useContext(AjaxContext);
	const {
		selectedUser: { uid }
	} = useContext(UserDetailsContext);
	const { permissionsConfig } = useContext(UserContext);

	const getUserWithdrawals = useCallback(async (filters?: WithdrawalsFilters) => {
		const { appName } = app;
		const permission = _find(permissionsConfig, { actionName: ACTION.getUserWithdrawalsAdmin });
		const result = await postData({
			endpoint: `/dashboard/getUserWithdrawalsAdmin/${USER_PROFILE_RESOURCES.paymentsStatus}-${USER_PAYMENTS_STATUS_RESOURCES.userWithdrawals}-getUserWithdrawalsAdmin`,
			queryParams: {
				appName
			},
			body: {
				uid,
				fromToDate: filters?.fromToDate,
				transactionId: filters?.transactionId
			},
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});

		const data = _get(result, ['data', 'data'], EMPTY_ARRAY);

		return { rowCount: data.length, data: formatListData(data) };
	}, []);

	return { getUserWithdrawals };
};

export default useService;
